// @flow

import { CustomerNumber } from './customer-number'
import type { ContactPersonDetails } from './contact-details'
import { buildContactPersonDetails } from './contact-details'
import type { PrimaryAddress } from './primary-address'
import { buildPrimaryAddress } from './primary-address'
import type { PostAddress } from './post-address'
import { buildPostAddress } from './post-address'
import type { VisitAddress } from './visit-address'
import { buildVisitAddress } from './visit-address'

export type Company = ContactPersonDetails & {
  reference?: ?CustomerNumber,
  accountNumber?: ?string,
  organisationName?: ?string,
  kvkNumber?: ?string,
  function?: ?string,
  phoneNumber?: ?string,
  phoneNumber2?: ?string,
  primaryAddress?: PrimaryAddress,
  postAddress?: PostAddress,
  visitAddress?: VisitAddress
}

const buildCompany = (): Company => {
  return {
    reference: null,
    accountNumber: '',
    organisationName: '',
    kvkNumber: '',
    function: '',
    phoneNumber: '',
    phoneNumber2: '',
    primaryAddress: buildPrimaryAddress(),
    postAddress: buildPostAddress(),
    visitAddress: buildVisitAddress(),
    ...buildContactPersonDetails()
  }
}

export {
  buildCompany
}



// WEBPACK FOOTER //
// ./src/types/company.js